module.exports = __webpack_public_path__ + "img/reference49.be52242b.jpg";